module.exports = "<app-top-view> </app-top-view>\n<app-mid-view></app-mid-view>"


//////////////////
// WEBPACK FOOTER
// P:/Portfolio-angular-master/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main